/**
 * Spacing + radius scale. A 2/4/6/8/12/16/20/24 ladder covering the
 * paddings/gaps observed across the UI. Numbers (px) so they drop straight
 * into `style={{ padding: SPACE.lg }}`.
 */
export const SPACE = {
  none: 0,
  xxs: 2,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  xxl: 20,
  xxxl: 24,
} as const;

export const RADII = {
  none: 0,
  sm: 3,
  md: 4,
  lg: 8,
  xl: 12,
  pill: 9999,
} as const;

export type SpaceKey = keyof typeof SPACE;
export type RadiusKey = keyof typeof RADII;
